<p-dialog header="Remarks" [(visible)]="showRemarks" modal="modal" width="300" >
  <ara-textarea [sourceText]="remark.RemarkText" [maxLength]="1000" disabled="false"
    (output)="getRemarks($event,'RemarkText')"></ara-textarea>
  <div *ngIf="showRemarkError && !remark.RemarkText">
    <span class="error-msg-colour">Please enter remarks</span>
  </div>
  <!-- <ara-file-upload [accept]="accept" multiple="true" (onInputFilesUpdatedData)="onInputFilesUpdated($event)"
  [(inputFiles)]="remark.RemarkFiles"></ara-file-upload> -->
  <!-- <ara-files-previewer [files]="PreviewFiles"></ara-files-previewer> -->
  <p-footer>
    <button type="button" pButton (click)="checkRemarkValidation()" label="Ok" class="active-btn orange-btn"></button>
    <button type="button" pButton (click)="onCancelClick()" label="Cancel" class="active-btn orange-btn"></button>
  </p-footer>
</p-dialog>
<i class="fa fa-plus-square" aria-hidden="true" (click)="showRemarksDialog($event)"></i>
